import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'

const getRoleRemediation = async (token, roleId) => {
  const url = `roles/${roleId}/sod_remediation`
  return apiGet({ url, token })
}

export default function useRoleRemediation({ roleId, options = {} }) {
  const token = useContext(AuthContext)

  return useQuery(
    ['role-remediation', roleId],
    () => getRoleRemediation(token, roleId),
    { refetchOnWindowFocus: false, staleTime: 5 * 60 * 1000, ...options }
  )
}
